<nav class="layout-breadcrumb">
    <ol>
        <li>
            <a [routerLink]="homeLink">
                <!-- <i class="pi pi-home"></i> -->
                Home
            </a>
        </li>
        <li class="layout-breadcrumb-chevron">></li>
        <ng-template
            ngFor
            let-item
            let-last="last"
            [ngForOf]="breadcrumbs$ | async"
        >
            <li>{{ item.label | translate }}</li>
            <li *ngIf="!last" class="layout-breadcrumb-chevron">></li>
        </ng-template>
    </ol>
</nav>
